export default (eventAction, eventLabel) => {
  return {
    event: 'TC&AV',
    eventCategory: 'Modal TC&AP',
    eventAction: eventAction, // Dynamic Data
    eventLabel: eventLabel, // Dynamic Data
  };
};